var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Dollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-dollar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,14h-1a.5.5,0,0,1-.5-.5V15a2,2,0,0,1-2-2v-.75a.5.5,0,0,1,.5-.5H8.25a.5.5,0,0,1,.5.5v1h2.5v-.88a.221.221,0,0,0-.09-.19L7.73,9.35A1.992,1.992,0,0,1,7,7.81V7A2,2,0,0,1,9,5V4.5A.5.5,0,0,1,9.5,4h1a.5.5,0,0,1,.5.5V5a2,2,0,0,1,2,2v.75a.5.5,0,0,1-.5.5h-.75a.5.5,0,0,1-.5-.5v-1H8.75v.88a.221.221,0,0,0,.09.19l3.43,2.83A1.992,1.992,0,0,1,13,12.19V13a2,2,0,0,1-2,2v.5A.5.5,0,0,1,10.5,16Z",
    transform: "translate(2 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Dollar);
export default __webpack_public_path__ + "static/media/icon-24-dollar.0fbedd27928f95e7a6f37f2451606d0c.svg";
export { ForwardRef as ReactComponent };